import React, { useState, useEffect, useContext } from 'react'
import {
  OverlayTrigger,
  Tooltip,
  Tab,
  Tabs,
  Table,
  Row,
  Col,
  Form,
  Button,
} from 'react-bootstrap'
import { AuthContext } from '../AuthContext'
import { useMediaQuery } from 'react-responsive'
import * as dayjs from 'dayjs'
import { v4 as uuidv4 } from 'uuid'
import { auto } from '@popperjs/core'
import axios from 'axios'

const GroupFanRanking = ({ title, incLastData, setIncLastData }) => {
  const { currentUser, BaseUrl } = useContext(AuthContext)
  const getIncLast = 'fanValue/v2/GetIncLast'

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      這個指標能夠告訴您旗下所有子品牌/企業，在不同社群來源的粉絲人數，包含增加/流失的情形。排名是依據總粉絲數由高至低排序。
    </Tooltip>
  )
  const today = dayjs().format('YYYY-MM-DD')
  const [date, setDate] = useState(today)

  const handleDateChange = (event) => {
    setDate(event.target.value)
  }
  const searchDate = () => {
    // console.log(startDate, endDate)
    axios
      .post(
        BaseUrl + getIncLast,
        { date: date },
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            Accept: '*/*',
            tk: currentUser.tk,
          },
        }
      )
      .then((res) => {
        console.log('fan getIncLast data', res.data.data)
        setIncLastData(res.data.data)
      })
      .catch((e) => {
        console.log(e)
      })
    if (date === '') {
      alert('日期格式錯誤')
    }
    //  else if (startDate && endDate && startDate > endDate) {
    //   alert('結束日期不得小於開始日期')
    // }
  }

  const [sortedTotalFB, setSortedTotalFB] = useState([])
  const [sortedTotalIG, setSortedTotalIG] = useState([])
  const [sortedTotalYT, setSortedTotalYT] = useState([])
  const isMobile = useMediaQuery({ query: '(max-width: 576px)' })

  useEffect(() => {
    setSortedTotalFB(
      [...incLastData].sort(function (a, b) {
        return b.count_fb - a.count_fb
      })
    )
    setSortedTotalIG(
      [...incLastData].sort(function (a, b) {
        return b.count_ig - a.count_ig
      })
    )
    setSortedTotalYT(
      [...incLastData].sort(function (a, b) {
        return b.count_yt - a.count_yt
      })
    )
    // console.log(incLastData)
  }, [incLastData])

  return (
    <>
      <Row className="d-flex flex-column flex-lg-row justify-content-between ">
        <Col className="my-2">
          <h4 className="fw-bolder px-3 p-lg-3 mt-3">
            {title}
            <OverlayTrigger
              placement="right"
              delay={{ show: 50, hide: 400 }}
              overlay={renderTooltip}
            >
              <div className="fas fa-question-circle p-1 text-decoration-none"></div>
            </OverlayTrigger>
          </h4>
        </Col>

        <Col className="my-2 ">
          <Form className="d-flex flex-row flex-sm-row px-3 p-lg-3 align-items-center">
            {/* <Col className="m-2"> */}
            <Form.Label className="mx-2 m-sm-2">日期</Form.Label>
            {/* </Col> */}
            <Col className="d-flex align-items-center justify-content-between">
              <Col className="mx-2 m-sm-2">
                <Form.Control
                  type="date"
                  value={date}
                  onChange={handleDateChange}
                />
              </Col>
              <Col md={auto} lg={auto}>
                <Button variant="secondary" type="button" onClick={searchDate}>
                  <i className="fa-solid fa-search "></i>
                  <span className=""> 查詢</span>
                </Button>
              </Col>
            </Col>
          </Form>
        </Col>
      </Row>

      <div className="fixedLeftCol">
        <Tabs
          defaultActiveKey="facebook"
          id="justify-tab-example"
          className="mb-2"
          justify
          //   variant="pills"
        >
          <Tab eventKey="facebook" title="Facebook">
            <Table striped hover>
              <thead>
                <tr>
                  <th className="headcolFirst">{isMobile ? '#' : '排行'}</th>
                  <th className="headcolSecond">品牌</th>
                  <th className="long">追蹤/訂閱人數</th>
                  <th className="long">近 7 日累積新粉數</th>
                  <th className="long">近 30 日累積新粉數</th>
                </tr>
              </thead>
              <tbody>
                {sortedTotalFB.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td className="headcolFirst">{i + 1}</td>
                      <td className="headcolSecond">{v.kol_name}</td>
                      <td className="long">{v.count_fb}</td>
                      <td className="long">{v.fans_accm_7d_fb}</td>
                      <td className="long">{v.fans_accm_30d_fb}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="instagram" title="Instagram">
            <Table striped hover>
              <thead>
                <tr>
                  <th className="headcolFirst">{isMobile ? '#' : '排行'}</th>
                  <th className="headcolSecond">品牌</th>
                  <th className="long">追蹤/訂閱人數</th>
                  <th className="long">近 7 日累積新粉數</th>
                  <th className="long">近 30 日累積新粉數</th>
                </tr>
              </thead>
              <tbody>
                {sortedTotalIG.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td className="headcolFirst">{i + 1}</td>
                      <td className="headcolSecond">{v.kol_name}</td>
                      <td className="long">{v.count_ig}</td>
                      <td className="long">{v.fans_accm_7d_ig}</td>
                      <td className="long">{v.fans_accm_30d_ig}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="youtube" title="YouTube">
            <Table striped hover>
              <thead>
                <tr>
                  <th className="headcolFirst">{isMobile ? '#' : '排行'}</th>
                  <th className="headcolSecond">品牌</th>
                  <th className="long">追蹤/訂閱人數</th>
                  <th className="long">近 7 日累積新粉數</th>
                  <th className="long">近 30 日累積新粉數</th>
                </tr>
              </thead>
              <tbody>
                {sortedTotalYT.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td className="headcolFirst">{i + 1}</td>
                      <td className="headcolSecond">{v.kol_name}</td>
                      <td className="long">{v.count_yt}</td>
                      <td className="long">{v.fans_accm_7d_yt}</td>
                      <td className="long">{v.fans_accm_30d_yt}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </div>
    </>
  )
}

export default GroupFanRanking
